const sizes = {
  sm: "w-7 h-7 text-xs",
  md: "w-9 h-9 text-sm",
  lg: "w-11 h-11 text-base",
};

const Avatar = ({ name, surname, image, size = "md" }) => {
  const initials = `${name?.[0] ?? ""}${surname?.[0] ?? ""}`.toUpperCase();

  if (image)
    return (
      <img
        src={image}
        alt={`${name} ${surname}`}
        className={`${sizes[size]} rounded-full object-cover flex-shrink-0`}
      />
    );

  return (
    <div
      className={`${sizes[size]} rounded-full ingroove-gradient-bg flex items-center justify-center text-white font-bold flex-shrink-0`}
    >
      {initials}
    </div>
  );
};

export default Avatar;
